import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Form, Input } from "reactstrap";
import { setHeaderTitle } from "../../actions/HeaderActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import axios from "axios";
import { setDetails, setProfilePic } from "../../actions/AccountActions";
import { changeLangAction } from "../../actions/WelcomeActions";
import { messages } from "../../constants/messages";
import { messages_ar } from "../../constants/messages_ar";
import { messages_kk } from "../../constants/messages_kk";
import { messages_fr } from "../../constants/messages_fr";
import { messages_sv } from "../../constants/messages_sv";
import { messages_no } from "../../constants/messages_no";
import { messages_vi } from "../../constants/messages_vi";
import { messages_tr } from "../../constants/messages_tr";
import { messages_it } from "../../constants/messages_it";
import { messages_es } from "../../constants/messages_es";
import { messages_cy } from "../../constants/messages_cy";
import { messages_el } from "../../constants/messages_el";
import { messages_ro } from "../../constants/messages_ro";
import { messages_cz } from "../../constants/messages_cz";
import { messages_pt } from "../../constants/messages_pt";
import { messages_lt } from "../../constants/messages_lt";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { showMessage } from "../../actions/FlashMessageActions";
import * as vars from "../../constants/variables";
import { console_log, formatDate } from "../../utils/helper";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { sendData } from "../../analytics/sendData";
import { isGamiclub } from "../../constants/isGamiclub";
import { messages_de } from "../../constants/messages_de";
import { isAppspool } from "../../constants/isAppspool";
import { isGameflares, isGamiway } from "../../constants/productCondition";
import { isWithdrawEnabled } from "../../constants/enableWithdraw";
import { getDomainTheme } from "../../utils/domainTheme";

var arabicDomain,
  kazakhDomain,
  orangeDomain,
  ciDomain,
  cdDomain,
  tnDomain,
  frenchDomain,
  snDomain,
  swedishDomain,
  cmDomain,
  kwDomain,
  belgiumDomain,
  zaDomain,
  norwayDomain,
  vietnamDomain,
  dzDomain,
  egDomain,
  turkeyDomain,
  spanishDomain,
  ghDomain,
  italianDomain,
  rsDomain,
  deDomain,
  roDomain,
  bfDomain,
  czDomain;
let msg;

class Account extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      emailAddress: "",
      location: "",
      interests: [],
      accountType: "standard",
      photo: "",
      photoFile: null,
      errorUnsub: "",
    };

    this.editForm = this.editForm.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onCategoryChange = this.onCategoryChange.bind(this);
    this.onFileChange = this.onFileChange.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.translateInterests = this.translateInterests.bind(this);
    this.unsubscribe = this.unsubscribe.bind(this);
    this.unsubscribePE = this.unsubscribePE.bind(this);
    this.changeDomain = this.changeDomain.bind(this);
  }

  componentWillMount() {
    if (this.props.access.token != "") {
      axios.defaults.headers.common["authorization"] = this.props.access.token;
    }
  }
  componentDidMount() {
    sendData("", "", "", "viewed", { page: "account" });
    let user = this.props.account.user;
    this.setState({
      name: user.name,
      emailAddress: user.email,
      location: user.address,
      interests: user.userInterests
        ? user.userInterests.map((i) => {
            return i.interestId;
          })
        : [],
      accountType: user.accountType,
    });

    window.scrollTo(0, 0);
  }

  componentWillUnmount() {
    document.body.classList.remove("<account-page></account-page>");
  }
  changeDomain() {
    arabicDomain = config.lang == "ar" ? true : false;
    kazakhDomain = config.lang == "kk" ? true : false;
    orangeDomain = config.country == "ci" ? true : false;
    ciDomain = config.country == "ci" ? true : false;
    cdDomain = config.country == "cd" ? true : false;
    tnDomain = config.country == "tn" ? true : false;
    frenchDomain = config.lang == "fr" ? true : false;
    snDomain = config.country == "sn" ? true : false;
    swedishDomain = config.country == "se" ? true : false;
    cmDomain = config.country == "cm" ? true : false;
    kwDomain = config.country == "kw" ? true : false;
    belgiumDomain = config.country == "be" ? true : false;
    zaDomain = config.country == "za" ? true : false;
    norwayDomain = config.country == "no" ? true : false;
    vietnamDomain = config.country == "vn" ? true : false;
    dzDomain = config.country == "dz" ? true : false;
    egDomain = config.country == "eg" ? true : false;
    ghDomain = config.country == "gh" ? true : false;
    turkeyDomain = config.country == "tr" ? true : false;
    spanishDomain = config.subDomain == "es" ? true : false;
    italianDomain = config.subDomain == "it" ? true : false;
    rsDomain = config.subDomain == "cy" ? true : false;
    deDomain = config.subDomain == "ch" ? true : false;
    roDomain = config.subDomain == "ro" ? true : false;
    bfDomain = config.country == "bf" ? true : false;
    czDomain = config.country == "cz" ? true : false;
    switch (config.lang) {
      case "ar":
        msg = messages_ar;
        break;
      case "kk":
        msg = messages_kk;
        break;
      case "fr":
        msg = messages_fr;
        break;
      case "sv":
        msg = messages_sv;
        break;
      case "no":
        msg = messages_no;
        break;
      case "vi":
        msg = messages_vi;
        break;
      case "tr":
        msg = messages_tr;
        break;
      case "cy":
        msg = messages_cy;
        break;
      case "es":
        msg = messages_es;
        break;
      case "it":
        msg = messages_it;
        break;
      case "de":
        msg = messages_de;
        break;
      case "el":
        msg = messages_el;
        break;
      case "ro":
        msg = messages_ro;
        break;
      case "cs":
        msg = messages_cz;
        break;
      case "pt":
        msg = messages_pt;
        break;
      case "lt":
        msg = messages_lt;
        break;
      default:
        msg = messages;
        break;
    }
  }
  translateInterests(interests, lang) {
    const translatedInterests = interests.map((interest) => {
      var inE = ["Sports", "Action", "Adventure", "Fitness", "Entertainment"];
      var inK = ["Спорт", "Экшн", "Приключения", "Фитнес", "Развлечения"];
      var inFrench = [
        "Sports",
        "Action",
        "Aventure",
        "Entraînement physique",
        "Divertissement",
      ];
      var inSwedish = [
        "Sporter",
        "Action",
        "Äventyr",
        "Träning",
        "Underhållning",
      ];
      var inArabic = [
        "رياضة",
        " اكشن",
        "مغامرة",
        "اللياقه البدنيه",
        "وسائل الترفيه",
      ];
      var inBelgium = ["Sport", "Actie", "Avontuur", "Geschiktheid", "Vermaak"];
      var inNo = ["Sport", "Action", "Eventyr", "Fitness", "Underholdning"];
      var inVietnam = ["Thể thao", "Hành động", "Phiêu lưu", "Gym", "Giải trí"];
      var inTurkey = ["Spor", "Aksiyon", "Macera", "Fitness", "Eğlence"];
      var inSpanish = [
        "Deporte",
        "Acción",
        "Aventura",
        "Fitness",
        "Entretenimiento",
      ];
      var inItalian = [
        "Sport",
        "Azione",
        "Avventura",
        "Fitness",
        "Intrattenimento",
      ];
      var inSerbian = ["Спортови", "Акција", "Авантура", "Фитнес", "Забава"];
      var inGerman = [
        "Sports",
        "Aktion",
        "Abenteuer",
        "Fitness",
        "Unterhaltung",
      ];
      var inGreek = ["Σπορ", "Δράση", "Περιπέτεια", "Fitness", "Διασκέδασης"];
      var inRo = ["Sport", "Acțiune", "Aventură", "Fitness", "Divertisment"];
      var inPt = ["Desportos", "Ação", "Aventura", "Fitness", "Entretenimento"];
      var inLt = ["Sportas", "Veiksmas", "Nuotykiai", "Fitnesas", "Pramogos"];
      var index = inE.indexOf(interest);
      if (index != -1) {
        if (lang == "kk") interest = inK[index];
        else if (lang == "fr") interest = inFrench[index];
        else if (lang == "sv") interest = inSwedish[index];
        else if (lang == "ar") interest = inArabic[index];
        else if (lang == "be") interest = inBelgium[index];
        else if (lang == "no") interest = inNo[index];
        else if (lang == "vi") interest = inVietnam[index];
        else if (lang == "tr") interest = inTurkey[index];
        else if (lang == "es") interest = inSpanish[index];
        else if (lang == "it") interest = inItalian[index];
        else if (lang == "cy") interest = inSerbian[index];
        else if (lang == "de") interest = inGerman[index];
        else if (lang == "gr") interest = inGreek[index];
        else if (lang == "ro") interest = inRo[index];
        else if (lang == "pt") interest = inPt[index];
        else if (lang == "lt") interest = inLt[index];
        else interest = inE[index];
      }
      return interest;
    });
    return translatedInterests;
  }
  onChange(e) {
    this.setState({
      [e.target.name]: e.target.value,
    });
  }
  editForm(e) {
    if (this.validateForm()) {
      this.submitForm();
    }
  }
  unsubscribePE() {
    const rockmanId =
      this.props.access.subscriptionData.rockmanId ||
      this.props.access.subscriptionData.rockman_id ||
      "fdf098fcc6";
    if (!rockmanId) {
      this.props.showMessage({
        message: "Disculpe, se produjo un error al darle de baja",
        type: false,
      });
      return;
    }
    axios
      .get(`${vars.BASE_URL}/unsubscribe?rockmanId=${rockmanId}&country=pe`)
      .then((response) => {
        if (response.data && response.data.success) {
          // sessionStorage.clear();
          this.props.showMessage({
            message: "Su suscripción ha sido correctamente cancelada",
            type: true,
          });
          // setTimeout(() => {
          //     this.props.history.push("/login");
          // }, 1500)
        } else {
          this.props.showMessage({
            message: "Disculpe, se produjo un error al darle de baja",
            type: false,
          });
          return;
        }
      })
      .catch((err) => {
        this.props.showMessage({
          message: "Disculpe, se produjo un error al darle de baja",
          type: false,
        });
      });
  }
  validateForm() {
    let regExp =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (
      this.state.emailAddress != "" &&
      !regExp.test(this.state.emailAddress)
    ) {
      this.props.showMessage({
        message: msg.emailNotValid,
        type: false,
      });
      return false;
    }
    return true;
  }

  submitForm() {
    let user = this.props.account.user;
    user.name = this.state.name;
    user.email = this.state.emailAddress;
    user.address = this.state.location;
    user.interests = this.state.interests;
    user.accountType = this.state.accountType;

    axios
      .put(vars.BASE_URL + "/editProfile", user)
      .then((response) => {
        this.props.showMessage({
          message: msg.profileSaved,
          type: true,
        });
        console_log(response);
      })
      .catch((error) => {
        console_log(error);
      });

    this.props.setDetails(user);
  }

  onCategoryChange(e) {
    let interest = this.state.interests,
      indexOf = interest.indexOf(parseInt(e.target.name));
    if (indexOf == -1) {
      interest.push(parseInt(e.target.name));
    } else {
      interest = interest.filter((c) => c !== parseInt(e.target.name));
    }

    this.setState({
      interests: interest,
    });
  }
  onFileChange(e) {
    let reader = new FileReader(),
      file = e.target.files[0];
    let base64Data;
    reader.readAsDataURL(file);
    let currentThis = this;
    reader.onloadend = function () {
      base64Data = reader.result;
      currentThis.props.show();
      axios
        .post(vars.BASE_URL + "/profile/upload", { profilePic: base64Data })
        .then((response) => {
          currentThis.props.showMessage({
            message: msg.profilePic,
            type: true,
          });
          currentThis.props.setProfilePic(response.data.data.profilePic);
          currentThis.props.hide();
        })
        .catch((error) => {
          currentThis.props.hide();
          console_log(error);
        });
      currentThis.setState({
        photo: [reader.result],
        photoFile: file,
      });
    };
  }
  unsubscribe() {
    let uid = this.props.access.uid;
    let lang = this.props.access.currentLang;
    let url = window.location.origin;
    sendData("", "", "", "unsubscribe clicked");
    let country = config.country;
    if (
      this.props.access.uid &&
      (cdDomain ||
        tnDomain ||
        snDomain ||
        cmDomain ||
        vietnamDomain ||
        ciDomain ||
        orangeDomain)
    ) {
      if ((cmDomain || ciDomain) && isGamiclub) {
        window.location = `http://n.gamiclub.com/unsubscribe/${country}?lang=fr&token=${uid}`;
      } else if (ciDomain || orangeDomain) {
        window.location = `http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&token=${uid}`;
      } else if (snDomain && isGamiclub) {
        window.location = `http://n.gamiclub.com/unsubscribe/sn?lang=fr&token=${uid}`;
      } else {
        window.location = `http://n.lordgames.info/unsubscribe/${country}?lang=${lang}&token=${uid}`;
      }
    } else if (this.props.access.uid && belgiumDomain && isGamiclub) {
      window.location = `http://n.gamiclub.com/unsubscribe/be/?lang=${config.lang === "be" ? "nl" : config.lang}&token=${uid}`;
    } else if (this.props.access.uid && belgiumDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/be/?domain=be.game-lords.com&token=${uid}`;
    } else if (this.props.access.uid && kwDomain) {
      window.location = `http://n.lordgames.info/unsubscribe/kw?domain=${isGamiclub ? "kw.gamiclub.com" : "kw.game-lords.com"}&platform=mcb&msisdn[]=${this.props.access.subscriptionData.msisdn_full.slice(3)}&skip_identify=1`;
    } else if (this.props.access.uid && config.subDomain === "maxis") {
      window.location = `https://m.game-lords.com/unsubscribe/my?lang=en&domain=${config.subDomain}.game-lords.com&platform=mcb&skip_identify=true&token=${uid}`;
    } else if (this.props.access.uid && config.subDomain === "my") {
      window.location = `https://checksubscription.com/?c=my`;
    } else if (
      this.props.access.uid &&
      config.subDomain === "pl" &&
      window.location.hostname.includes("funzarena")
    ) {
      window.location = `https://checksubscription.com/?c=pl`;
    } else if (this.props.access.uid && zaDomain && isGamiclub) {
      window.location = `http://n.gamiclub.com/unsubscribe/za?lang=en&token=${uid}`;
    } else if (this.props.access.uid && czDomain && isGamiclub) {
      window.location = `http://n.gamiclub.com/unsubscribe/cz?lang=cz&token=${uid}`;
    } else if (this.props.access.uid && zaDomain) {
      if (sessionStorage.getItem("staging")) {
        window.location = `http://ads-za-yola.sam-media.com/unsubscribe/za1?country=vn&lang=en&token=${uid}`;
      } else {
        window.location = `http://n.game-lords.com/unsubscribe/za/?domain=za.game-lords.com&country=za&lang=en&token=${uid}`;
      }
    } else if (this.props.access.uid && dzDomain) {
      if (config.lang === "ar") {
        window.location = `http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&lang=ar&token=${uid}`;
      } else if (config.lang === "fr") {
        window.location = `http://n.game-lords.com/unsubscribe/dz/?domain=dz.game-lords.com&token=${uid}`;
      }
    } else if (this.props.access.uid && egDomain) {
      if (config.lang === "ar") {
        window.location = ` http://n.game-lords.com/unsubscribe/eg/?country=eg&lang=ar&domain=eg.game-lords.com&token=${uid}`;
      } else {
        window.location = ` http://n.game-lords.com/unsubscribe/eg/?country=eg&lang=en&domain=eg.game-lords.com&token=${uid}`;
      }
    } else if (this.props.access.uid && turkeyDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/tr/?domain=tr.game-lords.com&token=${uid}`;
    } else if (this.props.access.uid && norwayDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/no?lang=no&token=${uid}`;
    } else if (this.props.access.uid && spanishDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=${uid}`;
    } else if (this.props.access.uid && ghDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/gh/?token=${uid}`;
    } else if (this.props.access.uid && swedishDomain) {
      window.location = `http://n.lordgames.info/unsubscribe/se?lang=sv&token=${uid}`;
    } else if (this.props.access.uid && italianDomain) {
      window.location = `http://n.game-lords.com/unsubscribe/it/?domain=it.game-lords.com&token=${uid}`;
    } else if (
      this.props.access.uid &&
      config.subDomain === "bh" &&
      isGamiclub
    ) {
      window.location = `http://n.gamiclub.com/unsubscribe/bh/?domain=bh.gamiclub.com&token=${uid}`;
    } else if (
      this.props.access.uid &&
      (config.subDomain === "id" ||
        config.subDomain === "idsale" ||
        config.subDomain === "gmn") &&
      !isGamiclub
    ) {
      window.location = `https://m.game-lords.com/unsubscribe/id?lang=id&token=${uid}`;
    }
    // else if (this.props.access.uid && roDomain) {
    //     window.location = `http://n.gamiclub.com/unsubscribe/ro/?domain=ro.gamiclub.com&token==${uid}`;
    // }
    else if (this.props.access.uid && config.subDomain === "es2") {
      window.location = `http://n.beemobi.me/unsubscribe/es/?country=es&domain=es2.beemobi.me&token=${uid}`;
    } else if (this.props.access.uid && bfDomain && isGamiclub) {
      window.location = `http://n.gamiclub.com/unsubscribe/bf?lang=fr&token=${uid}`;
    } else if (
      this.props.access.uid &&
      config.subDomain === "ch" &&
      !isGamiclub &&
      !isAppspool
    ) {
      window.location = `http://n.game-lords.com/unsubscribe/ch?lang=${config.lang}&token=${uid}`;
    } else if (!this.props.access.uid) {
      this.setState({
        errorUnsub:
          "No uid found. Try again after logging in with a valid uid.",
      });
    }
    return;
  }
  unsubscribeText = () => {
    let unsubscribeText;
    if (zaDomain) {
      unsubscribeText = (
        <div className="unsub_text">
          <p>
            To unsubscribe dial *135*997# or Dial 082 135 for Vodacom Customer
            Support.
          </p>
          <p>
            Go to <a href="https://bit.ly/3if1lzJ">https://bit.ly/3if1lzJ</a> to
            manage your content services.
          </p>
        </div>
      );
    }
    return unsubscribeText;
  };
  render() {
    this.changeDomain();
    let PP_url, TC_url, unsubscribe_url, contactus_url;
    if (config.lang == "ar") {
      this.props.setHeaderTitle("حسابي");
    } else if (config.subDomain === "bg") {
      this.props.setHeaderTitle("Моят акаунт");
    } else if (kazakhDomain) {
      this.props.setHeaderTitle("Личный кабинет");
    } else if (config.lang == "fr") {
      this.props.setHeaderTitle("Mon compte");
    } else if (config.lang == "cy") {
      this.props.setHeaderTitle("Мој профил");
    } else if (config.lang == "de") {
      this.props.setHeaderTitle("Mein Konto");
    } else if (config.lang == "el") {
      this.props.setHeaderTitle("Ο λογαριασμός μου");
    } else if (config.lang == "ro") {
      this.props.setHeaderTitle("Contul meu");
    } else if (config.lang == "it") {
      this.props.setHeaderTitle("Il mio account");
    } else if (config.lang == "pt") {
      this.props.setHeaderTitle("Minha Conta");
    } else if (config.lang == "lt") {
      this.props.setHeaderTitle("Mano Paskyra");
    } else if (swedishDomain) {
      this.props.setHeaderTitle("Mitt konto");
      PP_url =
        "http://n.game-lords.com/se/tnc-game-lords?offer=1&device=pc&_next=privacy_policy.html&_extracted=b46947911ad34990bc9776146fc173b9&";
      TC_url = "http://n.game-lords.com/se/tnc-game-lords?device=pc&offer=1";
      unsubscribe_url = `http://n.lordgames.info/unsubscribe/se?lang=sv&token=${this.props.account.user.uid}`;
    } else if (norwayDomain) {
      this.props.setHeaderTitle("Min konto");
    } else if (vietnamDomain) {
      this.props.setHeaderTitle("Tài khoản của tôi");
    } else if (turkeyDomain) {
      this.props.setHeaderTitle("Hesabım");
    } else if (italianDomain) {
      this.props.setHeaderTitle("Il mio account");
    } else if (spanishDomain) {
      this.props.setHeaderTitle("Mi cuenta");
      contactus_url =
        "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=contact.html";
      TC_url =
        "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=general_conditions.html";
      unsubscribe_url = `http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=${this.props.account.user.uid}`;
    } else if (config.subDomain === "es2") {
      this.props.setHeaderTitle("Mi cuenta");
    } else if (config.subDomain === "pe") {
      this.props.setHeaderTitle("Mi cuenta");
    } else if (ghDomain) {
      this.props.setHeaderTitle("My Account");
      TC_url = "http://n.lordgames.info/gh/tnc-gamelords?device=pc&offer=1";
    } else if (egDomain) {
      this.props.setHeaderTitle("My Account");
      TC_url = `http://n.gamiclub.com/eg/eg-mm-gamiclub?offer=1&msisdn=${this.props.access.subscriptionData.msisdn}`;
    } else if (czDomain) {
      this.props.setHeaderTitle("Můj účet");
    } else this.props.setHeaderTitle("My Account");
    let editBtnClass = "edit-button";
    editBtnClass = config.lang == "ar" ? editBtnClass + " ar" : editBtnClass;
    let Unsubscribe;
    if (
      orangeDomain ||
      ciDomain ||
      cdDomain ||
      tnDomain ||
      snDomain ||
      cmDomain
    )
      Unsubscribe = "Se désabonner";
    else if (swedishDomain) Unsubscribe = "Avsluta prenumerationen";
    else if (belgiumDomain) Unsubscribe = "Uitschrijven";
    else if (norwayDomain) Unsubscribe = "Meld av";
    else if (vietnamDomain) Unsubscribe = "Hủy đăng ký";
    else if (config.lang == "ar") Unsubscribe = "الغاء الاشتراك";
    else if (turkeyDomain) Unsubscribe = "Üyelikten ayrıl";
    else if (spanishDomain || config.subDomain === "es2")
      Unsubscribe = "Cancelación";
    else if (config.lang == "fr") Unsubscribe = "Se désabonner";
    else if (config.lang == "it") Unsubscribe = "Annulla l'iscrizione";
    else if (config.lang === "de") Unsubscribe = "Abmelden";
    else if (config.subDomain === "pe") Unsubscribe = "Cancelar la suscripción";
    else if (czDomain) Unsubscribe = "ODHLÁSIT ODBĚR";
    else if (roDomain) Unsubscribe = " Anulare";
    else if (config.subDomain === "pt") Unsubscribe = "CANCELAR INSCRIÇÃO";
    else if (config.subDomain === "lt") Unsubscribe = "ATŠAUKTI PRENUMERATĄ";
    else if (config.subDomain === "pl") Unsubscribe = "Anuluj subskrypcję";
    else Unsubscribe = "Unsubscribe";
    var inE = ["Sports", "Action", "Adventure", "Fitness", "Entertainment"];
    inE = this.translateInterests(inE, config.lang);
    const { msisdn_full, rockmanId } = this.props.access.subscriptionData;
    const { lang, country, subDomain } = config;
    const productName = window.location.hostname;
    return (
      <section className="account">
        <button className={editBtnClass} onClick={this.editForm}>
          <FormattedMessage id="save" defaultMessage="Save" />
        </button>
        <Container fluid>
          <Form
            className={
              config.lang == "ar"
                ? "account-form account-form--editable ar"
                : "account-form account-form--editable"
            }
            action=""
            method="post"
          >
            <Row>
              <Col sm="8" xs="7">
                <div className="account__fields">
                  <h3
                    style={
                      isGamiclub
                        ? { color: "green" }
                        : isGameflares
                          ? { color: "#FF394B" }
                          : isGamiway
                            ? { color: "#b347a0" }
                            : null
                    }
                    className="account__title"
                  >
                    <FormattedMessage
                      id="accountDetails"
                      defaultMessage="Account Details"
                    />
                  </h3>
                  <div className="account__input">
                    <label className="account__input__label" htmlFor="name">
                      <FormattedMessage
                        id="accountName"
                        defaultMessage="Name"
                      />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="name"
                      id="name"
                      value={this.state.name}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="account__input">
                    <label
                      className="account__input__label"
                      htmlFor="emailAddress"
                    >
                      <FormattedMessage
                        id="accountEmail"
                        defaultMessage="Email Address"
                      />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="emailAddress"
                      id="emailAddress"
                      value={this.state.emailAddress}
                      onChange={this.onChange}
                    />
                  </div>
                  <div className="account__input">
                    <label className="account__input__label" htmlFor="location">
                      <FormattedMessage
                        id="accountLocation"
                        defaultMessage="Location"
                      />
                    </label>
                    <input
                      className="account__input__field"
                      type="text"
                      name="location"
                      id="location"
                      value={this.state.location}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                {this.props.account.interests ? (
                  <div className="account__fields">
                    <h3
                      style={
                        isGamiclub
                          ? { color: "green" }
                          : isGameflares
                            ? { color: "#FF394B" }
                            : isGamiway
                              ? { color: "#b347a0" }
                              : null
                      }
                      className="account__title"
                    >
                      <FormattedMessage
                        id="accountInterests"
                        defaultMessage="Interests"
                      />
                    </h3>
                    <span className="hint-text">
                      <FormattedMessage
                        id="accountChooseCategory"
                        defaultMessage="Choose 3 categories"
                      />
                    </span>
                    <div className="account__checkbox-wrap">
                      {this.props.account.interests.map((interest, k) => {
                        return (
                          <div key={k} className="account__input">
                            <input
                              type="checkbox"
                              className={
                                isGamiclub
                                  ? "common-checkbox-gamiclub"
                                  : isGameflares
                                    ? "common-checkbox gameflares-checkbox"
                                    : isGamiway
                                      ? "common-checkbox gamiway-checkbox"
                                      : "common-checkbox"
                              }
                              name={interest.interestId}
                              id={interest.interestId}
                              checked={
                                this.state.interests.indexOf(
                                  interest.interestId,
                                ) !== -1
                                  ? true
                                  : false
                              }
                              onChange={this.onCategoryChange}
                            />
                            <label
                              className="account__default__label"
                              htmlFor={interest.interestId}
                            >
                              <FormattedMessage
                                id={inE[k]}
                                defaultMessage={inE[k]}
                              />
                            </label>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                {config.subDomain === "pe" && !isGamiclub ? (
                  <div className="account__fields">
                    <h3
                      style={isGameflares ? { color: "#FF394B" } : null}
                      className="account__title"
                    >
                      <Button
                        color="warning"
                        style={
                          isGameflares
                            ? {
                                borderColor: "#FF394B",
                                backgroundColor: "#FF394B",
                                color: "#ffffff",
                              }
                            : null
                        }
                        onClick={this.unsubscribePE}
                      >
                        {Unsubscribe}
                      </Button>
                      {this.state.errorUnsub ? (
                        <h5 style={{ color: "white", marginTop: "5px" }}>
                          {this.state.errorUnsub}
                        </h5>
                      ) : null}
                    </h3>
                  </div>
                ) : null}

                {(config.subDomain === "es2" ||
                  spanishDomain ||
                  orangeDomain ||
                  ciDomain ||
                  cdDomain ||
                  tnDomain ||
                  snDomain ||
                  swedishDomain ||
                  cmDomain ||
                  belgiumDomain ||
                  kwDomain ||
                  norwayDomain ||
                  vietnamDomain ||
                  dzDomain ||
                  turkeyDomain ||
                  italianDomain ||
                  ghDomain ||
                  (config.subDomain === "bh" && isGamiclub) ||
                  (config.subDomain === "my" && isGamiclub) ||
                  (config.subDomain === "pl" &&
                    window.location.hostname.includes("funzarena")) ||
                  (bfDomain && isGamiclub) ||
                  (czDomain && isGamiclub) ||
                  ((config.subDomain === "id" ||
                    config.subDomain === "idsale" ||
                    config.subDomain === "gmn" ||
                    config.subDomain === "my" ||
                    config.subDomain === "maxis" ||
                    egDomain ||
                    config.subDomain === "ch") &&
                    !isGamiclub &&
                    !isAppspool &&
                    !isGamiway)) &&
                this.props.access.uid ? (
                  <div className="account__fields">
                    <h3
                      style={
                        isGamiclub
                          ? { color: "green" }
                          : isGameflares
                            ? { color: "#FF394B" }
                            : null
                      }
                      className="account__title"
                    >
                      <Button
                        color="warning"
                        style={
                          isGamiclub
                            ? {
                                backgroundColor: "green",
                                borderColor: "green",
                                color: "white",
                              }
                            : isGameflares
                              ? {
                                  borderColor: "#FF394B",
                                  backgroundColor: "#FF394B",
                                  color: "#ffffff",
                                }
                              : null
                        }
                        onClick={this.unsubscribe}
                      >
                        {Unsubscribe}
                      </Button>
                      {this.state.errorUnsub ? (
                        <h5 style={{ color: "white", marginTop: "5px" }}>
                          {this.state.errorUnsub}
                        </h5>
                      ) : null}
                    </h3>
                  </div>
                ) : null}
                {spanishDomain || swedishDomain || ghDomain ? (
                  <div className="account__fields">
                    <h3
                      style={isGamiclub ? { color: "green" } : null}
                      className="account__title"
                    >
                      <Button
                        style={
                          isGamiclub
                            ? {
                                backgroundColor: "green",
                                borderColor: "green",
                                color: "white",
                              }
                            : null
                        }
                        color="warning"
                        onClick={() => {
                          window.open(TC_url, "_blank");
                        }}
                      >
                        <FormattedMessage
                          id="tnc"
                          defaultMessage="Terms & Conditions"
                        />
                      </Button>
                    </h3>
                  </div>
                ) : null}
                {swedishDomain ? (
                  <div className="account__fields">
                    <h3
                      style={isGamiclub ? { color: "green" } : null}
                      className="account__title"
                    >
                      <Button
                        style={
                          isGamiclub
                            ? {
                                backgroundColor: "green",
                                borderColor: "green",
                                color: "white",
                              }
                            : null
                        }
                        color="warning"
                        onClick={() => {
                          window.open(PP_url, "_blank");
                        }}
                      >
                        <FormattedMessage
                          id="privacyPolicy"
                          defaultMessage="Privacy policy"
                        />
                      </Button>
                    </h3>
                  </div>
                ) : null}
                {kwDomain ||
                (norwayDomain && !isGamiclub) ||
                (deDomain && isGamiclub) ||
                (config.subDomain === "bh" && isGamiclub) ? (
                  <div className="account__fields">
                    <h3
                      style={isGamiclub ? { color: "green" } : null}
                      className="account__title"
                    >
                      <FormattedMessage
                        id="subscription_details"
                        defaultMessage="Subscription Details"
                      />
                      :
                    </h3>
                    <span className="hint-text">
                      <FormattedMessage
                        id="mobile_number"
                        defaultMessage="Mobile Number"
                      />
                      :{" "}
                      {config.subDomain === "bh"
                        ? this.props.access.subscriptionData["msisdn"]
                        : this.props.access.subscriptionData.msisdn_full}
                    </span>{" "}
                    <br />
                    <span className="hint-text">
                      <FormattedMessage
                        id="subscription_date"
                        defaultMessage="Subscription Date"
                      />
                      :{" "}
                      {config.subDomain === "bh" && isGamiclub
                        ? formatDate(
                            this.props.access.subscriptionData["subscribed_at"],
                          )
                        : this.props.access.subscriptionData.startDate}
                    </span>
                    <br />
                    <span className="hint-text">
                      <FormattedMessage
                        id="renewal_date"
                        defaultMessage="Renewal Date"
                      />
                      :{" "}
                      {config.subDomain === "bh" && isGamiclub
                        ? formatDate(
                            this.props.access.subscriptionData[
                              "next_renewal_date"
                            ],
                          )
                        : this.props.access.subscriptionData.renewalDate}
                    </span>
                    <br />
                    {kazakhDomain ? (
                      <span>
                        <span className="hint-text">
                          <FormattedMessage
                            id="expiry_date"
                            defaultMessage="Expiry date"
                          />
                          : {this.props.access.subscriptionData.expiryDate}
                        </span>
                        <br />
                      </span>
                    ) : null}
                    {config.subDomain !== "bh" ? (
                      <span>
                        <span className="hint-text">
                          <FormattedMessage
                            id="applied_plan"
                            defaultMessage="Applied Plan"
                          />
                          :{" "}
                          {this.props.access.subscriptionData.billingPlan ==
                            7 || norwayDomain ? (
                            <FormattedMessage
                              id="weekly"
                              defaultMessage="Weekly"
                            />
                          ) : this.props.access.subscriptionData.billingPlan ==
                            1 ? (
                            <FormattedMessage
                              id="daily"
                              defaultMessage="Daily"
                            />
                          ) : this.props.access.subscriptionData.billingPlan ==
                            30 ? (
                            <FormattedMessage
                              id="monthly"
                              defaultMessage="Monthly"
                            />
                          ) : (
                            ""
                          )}
                        </span>
                        <br />
                      </span>
                    ) : null}
                    {config.subDomain === "bh" && isGamiclub ? (
                      <span>
                        <span className="hint-text">
                          <FormattedMessage
                            id="billing_interval"
                            defaultMessage="Billing Interval"
                          />
                          :{" "}
                          {
                            this.props.access.subscriptionData[
                              "Billing Interval"
                            ]
                          }
                        </span>
                        <br />
                        <span className="hint-text">
                          <FormattedMessage id="price" defaultMessage="Price" />
                          :{" "}
                          {isNaN(this.props.access.subscriptionData["Price"])
                            ? "0"
                            : (
                                this.props.access.subscriptionData["Price"] /
                                100
                              ).toFixed(1)}
                        </span>
                        <br />
                        <span className="hint-text">
                          <FormattedMessage
                            id="service_description"
                            defaultMessage="Service Description"
                          />
                          : {this.props.access.subscriptionData["Description"]}
                        </span>
                        <br />
                      </span>
                    ) : null}
                    <span className="hint-text">
                      <FormattedMessage
                        id="service_name"
                        defaultMessage="Service Name"
                      />
                      : {isGamiclub ? "Gamiclub" : "Gamelords"}
                    </span>
                  </div>
                ) : null}
                {zaDomain && (
                  <div className="unsubscribe_text_section">
                    {this.unsubscribeText()}
                  </div>
                )}
                {isWithdrawEnabled(subDomain) && (
                  <div className="account__fields">
                    <a
                      href={`https://checksubscription.com/withdraw?c=${country}&product=${productName}&country=${country}&language=${lang}&portalSource=${productName}&rockmanId=${rockmanId}&msisdn=${msisdn_full || ""}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={
                        isGamiclub ? { color: "#57A67C" } : { color: "#f6a50e" }
                      }
                    >
                      <FormattedMessage
                        id="withdraw_from_contract"
                        defaultMessage="Withdraw from Contract"
                      />
                    </a>
                  </div>
                )}
              </Col>
              <Col sm="4" xs="5">
                <div className="account__image">
                  <div className="account__input">
                    <label
                      className="account__input__label account__input__label--image"
                      htmlFor="photo"
                    >
                      <img
                        className="avatar-image"
                        src={
                          this.state.photo
                            ? this.state.photo
                            : this.props.account.user.profilePic
                              ? this.props.account.user.profilePic
                              : "img/avatar-with-camera.png"
                        }
                        alt="Edit Photo"
                      />
                      <span className="avatar-text">
                        <FormattedMessage
                          id="accountEditPhoto"
                          defaultMessage="Edit Photo"
                        />
                      </span>
                    </label>
                    <input
                      type="file"
                      className="account__input__field"
                      name="photo"
                      id="photo"
                      accept="image/gif, image/jpeg, image/png image/jpg"
                      onChange={this.onFileChange}
                    />
                  </div>
                </div>
              </Col>
            </Row>
          </Form>
        </Container>
      </section>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    account: state.AccountReducer,
    access: state.WelcomeReducer,
    flashmessage: state.FlashMessageReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      show,
      hide,
      setHeaderTitle,
      setDetails,
      showMessage,
      setProfilePic,
      changeLangAction,
    },
    dispatch,
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Account);



// WEBPACK FOOTER //
// ./src/components/Account/Account.js